import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import DropdownMenu from './DropdownMenu';
import Logo from './LOGOjuandavid2.svg';
import Footer from './Footer';
import HomePage from './HomePage';

const ProceduresPage = lazy(() => import('./pages/ProceduresPage'));
const SurgeriesPage  = lazy(() => import('./pages/SurgeriesPage'));
const AboutPage      = lazy(() => import('./pages/AboutPage'));
const LandingRejuvenecimiento = lazy(() => import('./pages/LandingRejuvenecimiento'));

function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/rejuvenecimientofacial';

  if (isLandingPage) {
    return (
      <Suspense fallback={null}>
        <Routes>
          <Route path="/rejuvenecimientofacial" element={<LandingRejuvenecimiento />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <Link to="/">
          <img src={Logo} className="App-logo" alt="logo" />
        </Link>
        <DropdownMenu />
      </header>
      <main>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/procedures" element={<ProceduresPage />} />
            <Route path="/surgeries" element={<SurgeriesPage />} />
            <Route path="/shop/*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
